<template>
  <a-menu
    class="hm-web-menu"
    theme="light"
    mode="horizontal"
    :selectedKeys="selectedKeys"
    @click="onMenuSelect"
  >
    <a-menu-item key="home">首页</a-menu-item>
    <a-menu-item key="product-service">产品服务</a-menu-item>
    <!-- <a-popover trigger="hover" placement="bottomLeft" overlayClassName="product-subMenu">
      <template slot="content">
        <div class="product-subMenu-content">
          <div class="product-subMenu-wrap product">
            <span class="product-subMenu-title">产品<a-divider /></span>
            <a-row class="product-subMenu-list">
              <a-col :span="12" class="product-subMenu-item" :class="{'active': subMenuActiveKey === item.key }" v-for="item in productMenuList" :key="item.key" @click.prevent.stop="onClickMenu(item)">
                <p class="title">{{item.title}}</p>
                <p class="desc">{{item.desc}}</p>
              </a-col>
            </a-row>
          </div>
          <div class="product-subMenu-wrap service">
            <span class="product-subMenu-title">服务<a-divider /></span>
            <a-row class="product-subMenu-list">
              <a-col :span="24" class="product-subMenu-item" :class="{'active': subMenuActiveKey === item.key }" v-for="item in serviceMenuList" :key="item.key" @click.prevent.stop="onClickMenu(item)">
                <p class="title">{{item.title}}</p>
                <p class="desc">{{item.desc}}</p>
              </a-col>
            </a-row>
          </div>
        </div>
      </template>
      <li class="ant-menu-item" :class="{'ant-menu-item-selected': subMenuActiveKey !== ''}">产品服务</li>
    </a-popover> -->
    <a-popover trigger="hover" placement="bottomLeft">
      <template slot="content">
        <div class="service-content">
          <div class="video">
            <a-row type="flex" justify="space-between" class="margin-b-20">
              <a-col class="product-img" @click="onMenuSelect({key: 'video-product'})">
                <div class="info_title">税纪云介绍</div>
                <img src="@/assets/images/product_info.png" alt="">
              </a-col>
              <a-col class="product-img" @click="onMenuSelect({key: 'video-helper'})">
                <div class="info_title">AI 小助手</div>
                <img src="@/assets/images/ai_helper.png" alt="">
              </a-col>
              <a-col class="product-img" @click="onMenuSelect({key: 'video-shop'})">
                <div class="info_title">华为云商城</div>
                <img src="@/assets/images/hw_cloud.png" alt="">
              </a-col>
            </a-row>
          </div>
          <div class="AI-video">
            <a-divider>数字人视频</a-divider>
            <a-row class="product-subMenu-list" type="flex">
              <a-col :span="6" class="product-subMenu-item" :class="{'active': subMenuActiveKey === item.key }" v-for="item in AIVideoList" :key="item.key" @click.prevent.stop="onAIVideoClick(item)">
                <p class="title">{{item.title}}</p>
              </a-col>
            </a-row>
          </div>
        </div>
      </template>
      <li class="ant-menu-item" :class="{'ant-menu-item-selected': subMenuActiveKey === 'Video'}">产品视频</li>
    </a-popover>
    <!-- <a-sub-menu title="产品视频" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="video-product">产品介绍</a-menu-item>
      <a-menu-item key="video-shop">华为云商城</a-menu-item>
    </a-sub-menu> -->
    <!-- <a-sub-menu title="解决方案" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="solution-chain-retail">连锁零售</a-menu-item>
    </a-sub-menu> -->
    <a-menu-item key="case">行业案例</a-menu-item>
    <a-sub-menu title="新闻中心" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="news-advertisement">研讨活动</a-menu-item>
      <a-menu-item key="news-center">新闻动态</a-menu-item>
    </a-sub-menu>
    <a-menu-item key="salon-tax">财税沙龙</a-menu-item>
    <a-sub-menu title="关于华盟" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="introduce">华盟介绍</a-menu-item>
      <a-menu-item key="invite-job">华盟招聘</a-menu-item>
      <a-menu-item key="hm-style">华盟风采</a-menu-item>
      <a-menu-item key="about">联系我们</a-menu-item>
    </a-sub-menu>
    <!-- <a-sub-menu title="招聘" popupClassName="hm-web-menu__subMenu">
      <a-menu-item key="invite-job">华盟招聘</a-menu-item>
      <a-menu-item key="hm-style">华盟风采</a-menu-item>
    </a-sub-menu> -->
  </a-menu>
</template>

<script>
export default {
  name: 'hmMenu',
  data () {
    return {
      selectedKeys: ['home'],
      subMenuActiveKey: '',
      productMenuList: [
        { routeName: 'product', key: 'newTaxera', title: '税纪云', desc: '自主研发的智慧税务综合管理SaaS平台' },
        { routeName: 'product', key: 'taxcellent', title: 'Taxcellent', desc: '自建全球上市公司数据库和转让定价文档自动生成' },
        { routeName: 'product', key: 'chataxera', title: '金税一言', desc: '大模型AI税务专家' },
        { routeName: 'product', key: 'dec', title: '一键申报', desc: '自动化批量处理，简化税务流程' },
        { routeName: 'product', key: 'lawLibrary', title: '法规库', desc: '全面归集并实时更新最新政策法规和热点问题' },
        { routeName: 'product', key: 'ibd', title: '行业数据库', desc: '助力企业提高税务合规遵从度及信用评级' }
        // { routeName: 'product', key: 'fincellent', title: '财纪云', desc: '为初创及小微企业打造的记账报税一站式SaaS平台' },
        // { routeName: 'product', key: 'ftc', title: '财税专聘', desc: '一眼发现新未来' }
      ],
      serviceMenuList: [
        { routeName: 'service', key: 'product-tax-consulting', title: '税务咨询&外包服务', desc: '围绕税纪云平台开展税务咨询服务' },
        // { routeName: 'service', key: 'product-outsourcing-services', title: '外包服务', desc: '代理记账报税  税务鉴证服务  代TP文档准备  代外籍个税申报' },
        { routeName: 'international', key: 'product-global-platform', title: '国际服务', desc: '跨境税务咨询  海外并购咨询  跨境服务对接' }
      ],
      AIVideoList: [
        { key: 'GROUP_MANAGEMENT', title: '集团管理' },
        { key: 'EXPORT_REBATES', title: '出口退税' },
        { key: 'FINAL_SETTLEMENT', title: '汇算清缴' },
        { key: 'IIT', title: '个人所得税' },
        { key: 'NON_TRADE', title: '非贸付汇' },
        { key: 'RDTC', title: '研发加计' },
        { key: 'CHATAXERA', title: '金税一言' },
        { key: 'HKTAX', title: '香港利得税' },
        { key: 'ELECT_INVOICE', title: '数电票' },
        { key: 'TP', title: '转让定价' },
        { key: 'RETAIL_INDUSTRY', title: '零售行业' }
      ]
    }
  },
  watch: {
    '$route' (newRoute) {
      this.subMenuActiveKey = ''
      this.initMenu()
    }
  },
  created () {
    this.initMenu()
  },
  methods: {
    initMenu () {
      this.selectedKeys = []
      let key = this.$route.name
      if (key === 'product') {
        this.subMenuActiveKey = this.$route.params.type
      } else {
        const { name, meta: { nav } } = this.$route
        const selected = nav || name
        this.selectedKeys = [selected]
      }
    },
    onMenuSelect ({key}) {
      console.log('%c key', 'background-color: green;color: #fff;', key)
      if (!key) return
      if (['video-product', 'video-shop', 'video-helper'].includes(key)) {
        this.$bus.$emit('onShowVideo', key)
        return
      }
      console.log('%c点击菜单', 'background-color: green;color: #fff;', key)
      this.selectedKeys = [key]
      this.subMenuActiveKey = ''
      this.$router.push({
        name: key
      })
    },
    onClickMenu (record) {
      const { routeName, key } = record
      console.log('%c点击产品服务菜单', 'background-color: green;color: #fff;', record)
      this.subMenuActiveKey = key
      this.selectedKeys = []
      this.$router.push({
        name: routeName,
        params: { type: key }
      })
    },
    onAIVideoClick (record) {
      this.$bus.$emit('onShowVideo', 'AI', record.key)
      this.subMenuActiveKey = 'Video'
    }
  }
}
</script>

<style lang="less" scoped>
.hm-web-menu.ant-menu {
  background-color: #fff;
  height: 64PX;
  line-height: 64PX;
  font-size: 16PX;
  user-select: none;
  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: 0 8PX;
    margin-left: 8PX;
    margin-right: 8PX;
  }
  &.ant-menu-horizontal .ant-menu-item,
  &.ant-menu-horizontal .ant-menu-submenu {
    margin-top: -2PX;
  }
  &.ant-menu-horizontal > .ant-menu-item:hover,
  &.ant-menu-horizontal > .ant-menu-item-selected {
    color: #292F3A;
    font-weight: 600;
  }
}

.hm-web-menu__subMenu-product {
  .ant-menu-item-group {
    float: left;
  }
}

.product-subMenu {
  width: 1040PX;
  height: 320PX;
  &.ant-popover-placement-bottomLeft {
    padding-top: 0;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
  .ant-popover-arrow { display: none; }
  .product-subMenu-content {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .product-subMenu-title {
    padding-left: 14PX;
    font-size: 14PX;
    color: #848D9E;
    line-height: 30PX;
    font-weight: 600;
  }
  .ant-divider {
    margin: 10PX 0 0 0;
    color: #D8DDE6;
  }
  .product-subMenu-item {
    height: 66PX;
    padding: 12PX 16PX;
    margin-top: 16PX;
    border-radius: 6PX;
    transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
    cursor: pointer;
    .title {
      font-size: 14PX;
      color: #292F3A;
      line-height: 15PX;
      font-weight: 600;
    }
    .desc {
      margin-top: 7PX;
      font-size: 12PX;
      color: #848D9E;
      line-height: 12PX;
      font-weight: 400;
    }
    &.active,
    &:hover {
      opacity: 0.8;
      background-color: #E8EEF8;
      .title {
        color: #3E77FF;
      }
    }
  }
  .product-subMenu-wrap {
    padding: 16PX;
    &.product {
      width: 640PX;
    }
    &.service {
      width: 400PX;
      background-color: #F8F9FC;
      .desc {
        color: #292F3A;
      }
    }
  }
}
.hm-web-menu{
  /deep/ .ant-menu-submenu-selected{
    color: #292F3A;
    font-weight: bolder;
  }
  /deep/ .ant-menu-submenu-title:hover{
    color: #292F3A;
    font-weight: bolder;
  }
}
</style>
<style lang="less">
.hm-web-menu__subMenu {
  .ant-menu-vertical.ant-menu-sub {
    min-width: auto;
  }
  .ant-menu-vertical .ant-menu-item {
    padding: 0 24PX;
  }
}
.service-content {
  width: 424PX !important;
  padding: 20PX 16PX;
    .video {
      width: 100%;
      margin-top: 8PX;
      .margin-b-20 {
        margin-bottom: 1rem;
      }
      .product-img {
        position: relative;
        cursor: pointer;
        .info_title {
          position: absolute;
          top: 14PX;
          font-size: 14PX;
          text-align: center;
          width: 120PX;
          color: #292F3A;
          font-weight: 500;
        }
        img {
          width: 120PX;
        }
      }
    }
    .AI-video {
      .ant-divider {
        margin: 10PX 0 0 0;
        color: #D8DDE6;
        .ant-divider-inner-text{
          font-size: 12PX;
          color: #868991;
          line-height: 22PX;
          font-weight: 600;
        }
      }
      .product-subMenu-item {
        height: auto;
        margin-top: 10PX;
        padding: 8PX 12PX;
        border-radius: 6PX;
        font-size: 14PX;
        color: #292f3a;
        line-height: 15PX;
        .title {
          font-weight: 500;
        }
        p {
          margin-bottom: 0;
        }
        &.active,
        &:hover {
          opacity: 0.8;
          background-color: #E8EEF8;
          .title {
            color: #3E77FF;
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hm-menu/index.vue